module.exports = __webpack_public_path__ + "img/payBanner.903d2744.png";